import {
	ICountryValues,
	CountryValuesProductType,
} from 'shared/constants/countryValueTypes'

export const countryValues: ICountryValues[] = [
	{
		country: 'at',
		tfFullName: 'TF Bank (ein zweiter Firmenname von Avarda Bank AB (publ), Reg.-Nr. 556158-1041)',
		copyRight: 'TF Bank (ein zweiter Firmenname von Avarda Bank AB (publ), Reg.-Nr. 556158-1041)',
		address: {
			companyName: 'TF Bank (ein zweiter Firmenname von Avarda Bank AB (publ), Reg.-Nr. 556158-1041)',
			addressLine1: 'Postfach 0018',
			zipCodeAndCity: '2340 Mödling',
			country: 'Österreich',
		},
		links: () => {
			return {
				legal: {
					title: 'LegalInformation',
					link: 'https://tfbank.at/impressum',
				},
				dataProtection: {
					title: 'DataProtectionFooterTitle',
					link: 'https://tfbank.at/datenschutz',
				},
				faq: {
					title: 'Service',
					link: 'https://tfbank.at/service',
				},
				cookie: {
					title: 'Cookies',
					link: 'https://tfbank.at/cookies',
				},
			}
		},
		chatInfo: {
			supportTitle: 'Sie benötigen schnelle Unterstützung?',
			liveChatText: 'Unser Kundenservice ist im Live-Chat direkt für Sie erreichbar. Klicken Sie unten rechts auf das Chat-Symbol und ein Mitarbeiter kümmert sich während unserer Service-Zeiten persönlich um Ihr Anliegen.',
		},
		productSpecific: [
			{
				productType: CountryValuesProductType.Card,
				contactInformation: {
					email: 'service@tfbank.at',
					openingHours:
						'Sie erreichen uns montags bis freitags von 8:00 bis 18:00 Uhr',
				},
				bankInformation: {
					iban: 'DE77512202000070508402',
					bic: 'ESSEDEFFXXX',
				},
			},
		],
	},
	{
		country: 'de',
		tfFullName: 'TF Bank (ein zweiter Firmenname von Avarda Bank AB (publ), Reg.-Nr. 556158-1041)',
		copyRight: 'TF Bank (ein zweiter Firmenname von Avarda Bank AB (publ), Reg.-Nr. 556158-1041)',
		address: {
			companyName: 'TF Bank (ein zweiter Firmenname von Avarda Bank AB (publ), Reg.-Nr. 556158-1041)',
			addressLine1: 'Postfach 11 02 28',
			zipCodeAndCity: '10832 Berlin',
			country: 'Deutschland',
		},
		links: () => {
			return {
				legal: {
					title: 'LegalInformation',
					link: 'https://tfbank.de/impressum',
				},
				dataProtection: {
					title: 'DataProtection',
					link: 'https://tfbank.de/datenschutz',
				},
				faq: {
					title: 'Service',
					link: 'https://tfbank.de/service',
				},
				cookie: {
					title: 'Cookies',
					link: 'https://tfbank.de/cookies',
				},
			}
		},
		chatInfo: {
			supportTitle: 'Sie benötigen schnelle Unterstützung?',
			liveChatText: 'Unser Kundenservice ist im Live-Chat direkt für Sie erreichbar. Klicken Sie unten rechts auf das Chat-Symbol und ein Mitarbeiter kümmert sich während unserer Service-Zeiten persönlich um Ihr Anliegen.',
		},
		productSpecific: [
			{
				productType: CountryValuesProductType.Card,
				contactInformation: {
					email: 'service@tfbank.de',
					openingHours:
						'Sie erreichen uns montags bis freitags von 8:00 bis 18:00 Uhr',
				},
				bankInformation: {
					iban: 'DE77512202000070508402',
					bic: 'ESSEDEFFXXX',
				},
			},
			{
				productType: CountryValuesProductType.Deposit,
				contactInformation: {
					email: 'tagesgeld@tfbank.de',
					openingHours:
						'Sie erreichen uns montags bis freitags von 8:00 bis 18:00 Uhr',
				},
				bankInformation: {
					iban: 'DE06202208000000024118',
					bic: 'SXPYDEHH',
				},
			},
			{
				productType: CountryValuesProductType.Deposit_Fixed,
				contactInformation: {
					email: 'festgeld@tfbank.de',
					openingHours:
						'Sie erreichen uns montags bis freitags von 8:00 bis 18:00 Uhr',
				},
				bankInformation: {
					iban: 'DE06202208000000024118',
					bic: 'SXPYDEHH',
				},
			},
		],
	},
	{
		country: 'es',
		tfFullName: 'TF Bank (una denominación comercial secundaria de Avarda Bank AB (publ), n.º de registro 556158-1041)',
		copyRight: 'TF Bank (una denominación comercial secundaria de Avarda Bank AB (publ), n.º de registro 556158-1041)',
		address: {
			companyName: 'TF Bank (una denominación comercial secundaria de Avarda Bank AB (publ), n.º de registro 556158-1041)',
			addressLine1: 'Box 947, 501 10 Borås',
			zipCodeAndCity: 'Teléfono: 91 993 10 15 / 900 968 008',
			country: 'Email: clientes.tarjeta@tfbank.es',
		},
		links: () => {
			return {
				legal: {
					title: 'LegalInformation',
					link: 'https://tfbank.de/impressum',
				},
				dataProtection: {
					title: 'DataProtection',
					link: 'https://tfbank.de/datenschutz',
				},
				faq: {
					title: 'Service',
					link: 'https://tfbank.de/service',
				},
				cookie: {
					title: 'Cookies',
					link: 'https://tfbank.de/cookies',
				},
			}
		},
		productSpecific: [
			{
				productType: CountryValuesProductType.Card,
				contactInformation: {
					email: '',
					openingHours:
						'9:00 - 17:00 Monday - Thursday / 9:00 - 16:00 Friday',
				},
				bankInformation: {
					iban: 'DE77512202000070508402',
					bic: 'ESSEDEFFXXX',
				},
			},
		],
	},
	{
		country: 'it',
		tfFullName: 'TF Bank AB, una denominazione secondaria di Avarda Bank AB, num. reg. 556158-1041',
		copyRight: 'TF Bank AB, una denominazione secondaria di Avarda Bank AB, num. reg. 556158-1041',
		address: {
			companyName: 'TF Bank AB, una denominazione secondaria di Avarda Bank AB, num. reg. 556158-1041',
			addressLine1: 'Box 947, 501 10 Borås',
			zipCodeAndCity: 'Tel: 02 555 000/ 800 580 669',
			country: 'Email: info@tfbank.it',
		},
		links: () => {
			return {
				legal: {
					title: 'LegalInformation',
					link: 'https://tfbank.de/impressum',
				},
				dataProtection: {
					title: 'DataProtection',
					link: 'https://tfbank.de/datenschutz',
				},
				faq: {
					title: 'Service',
					link: 'https://tfbank.de/service',
				},
				cookie: {
					title: 'Cookies',
					link: 'https://tfbank.de/cookies',
				},
			}
		},
		productSpecific: [
			{
				productType: CountryValuesProductType.Card,
				contactInformation: {
					email: '',
					openingHours:
						'9:00 - 17:00 Monday - Thursday / 9:00 - 16:00 Friday',
				},
				bankInformation: {
					iban: 'DE77512202000070508402',
					bic: 'ESSEDEFFXXX',
				},
			},
		],
	},
	{
		country: 'no',
		tfFullName: 'Avarda Bank AB NUF',
		copyRight: 'Avarda Bank AB',

		links: () => {
			return {
				cookie: { link: 'https://www.tfbank.no/personvernerklaring/' },
				faq: { link: 'https://tfbank.no/hjelp' },
			}
		},
		address: {
			companyName: 'Avarda Bank AB NUF',
			addressLine1: 'Postboks 956 Sentrum',
			zipCodeAndCity: '5808, Bergen',
		},
		productSpecific: [
			{
				productType: CountryValuesProductType.Card,
				contactInformation: {
					email: 'kort@tfbank.no',
					phoneNumber: '56 99 92 00',
					openingHours:
						'Mandag - Fredag: 10:00-15:00',
				},
			},
			{
				productType: CountryValuesProductType.Deposit,
				contactInformation: {
					email: 'innskudd@tfbank.no',
					phoneNumber: '56 99 92 00',
					openingHours:
						'Mandag - Fredag: 10 :00-15:00',
				},
			},
			{
				productType: CountryValuesProductType.Loan,
				contactInformation: {
					email: 'post@tfbank.no',
				},
			},
		],
	},
]
